import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  getScoreExplainablity,
  getAmlsCommonPreventionScoreExplainablity,
  getAlertScoreExplanation
} from '../../../redux/actions/tmCommon';
import { fetchTypologiesActions } from '../../../redux/actions/common';
import { getAMLSCommonAlertPartyIdentity } from '../../../redux/actions/common';
import { fetchQueryBuilderMetadata } from '../../../redux/actions/common';
import { fetchAMLSAlertLevel } from '../../../redux/actions/common';
import ScoreExplainability from './ScoreExplainability';

function mapStateToProps(state) {
  const {
    scoreExplainability = {},
    preventionScoreExplainability = {},
    alertScoreExplanation = {}
  } = state.amlsTMCommon;
  const { data, error, isLoading } = scoreExplainability;

  return {
    scoreExplainability: data,
    error,
    authentication: state.authentication,
    isLoading: isLoading || preventionScoreExplainability?.isLoading,
    scoreExplainabilityPrevention: preventionScoreExplainability.data,
    alertScoreExplanation: alertScoreExplanation.data,
    unifiedAlerts: state.amlsCommon,
    trmActions: state.amlsCommon.commonTypologyAction,
    // FIN-11960 — same field metadata the Rule config screen uses for its
    // Group By / field labels (Functions.js reads state.amlsCommon.queryFields).
    fieldsMetaData: state.amlsCommon.queryFields?.data?.fields || {},
    // FIN-12133 — alert_level_details configs (code -> displayName/color) used to
    // colour-code the Action value by its configured severity's level colour.
    alertLevelConfigs: state.amlsCommon.alertLevelConfigs?.data || []
  };
}

function mapDispatchToProps(dispatch) {
  return {
    apiActions: bindActionCreators(
      {
        getScoreExplainablity,
        getAmlsCommonPreventionScoreExplainablity,
        getAlertScoreExplanation,
        getAMLSCommonAlertPartyIdentity,
        fetchTypologiesActions,
        fetchQueryBuilderMetadata,
        fetchAMLSAlertLevel
      },
      dispatch
    )
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScoreExplainability);
